import { IRPC } from '@prisma/studio-types'

import serialize from '../serialize'
import deserialize from '../deserialize'
import { ITransportBrowser } from '../types'

export default class HTTPTransport implements ITransportBrowser {
  private requestIdCounter: number = 0
  private baseUrl: string

  constructor(baseUrl: string = `${window.location.origin}/api`) {
    this.baseUrl = baseUrl
  }

  public request<T extends IRPC>(
    request: Omit<T['request'], 'requestId'>
  ): Promise<T['response']['payload']> {
    const url = new URL(this.baseUrl)

    return new Promise((resolve, reject) => {
      const requestId = this.requestIdCounter

      fetch(url.toString(), {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
        },
        body: serialize({
          requestId,
          channel: request.channel,
          action: request.action,
          payload: request.payload,
        }),
      })
        .then(async res => {
          if (res.status === 200) {
            const body = await res.text()
            const response = deserialize(body) as T['response']
            return resolve(response.payload)
          }

          console.error(
            'Non-200 Status Code in HTTPTransport.send. Body:',
            res.body
          )

          return reject({
            message: 'Error in HTTP Request',
            status: res.status,
            body: res.body,
          })
        })
        .catch(() => {
          // If you're here, it means something's up with the connection
          return reject({
            message:
              'Unable to communicate with Prisma Client. Is Studio still running? You may need to restart it using `npx prisma studio`',
            status: null,
            body: null,
          })
        })

      this.requestIdCounter++
    })
  }
}
